import request from "@/utils/request";

// 获取用户主页
export function getIndex(data) {
  return request({
    method: "post",
    path: "user/index",
    data,
  });
}

// 获取账户设置
export function getInfo(data) {
  return request({
    method: "post",
    path: "user/getInfo",
    data,
  });
}

// 获取用户手机号
export function getUserPhone(data) {
  return request({
    method: "post",
    path: "user/getPhone",
    data,
  });
}

// 保存账户设置
export function setInfo(data) {
  return request({
    method: "post",
    path: "user/setInfo",
    data,
  });
}

// 修改密码
export function setPassword(data) {
  return request({
    method: "post",
    path: "user/setPassword",
    data,
  });
}

// 修改支付密码
export function setPayPassword(data) {
  return request({
    method: "post",
    path: "user/setPayPassword",
    data,
  });
}

// 修改支付密码
export function setPhone(data) {
  return request({
    method: "post",
    path: "user/setPhone",
    data,
  });
}

// 获取优惠券列表
export function getCouponList(data) {
  return request({
    method: "post",
    path: "user/getCouponList",
    data,
  });
}

// 绑定优惠券
export function bindCoupon(data) {
  return request({
    method: "post",
    path: "user/bindCoupon",
    data,
  });
}

// 意见反馈
export function feedback(data) {
  return request({
    method: "post",
    path: "user/feedback",
    data,
  });
}
